module.exports = __webpack_public_path__ + "img/icon-check.7e5393d6.svg";